__webpack_require__.p = "https://storage.googleapis.com/static-ticker-prod-tt-news-com/";